import introImg from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.1.jpg';
import chapterImg2 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.1.jpg';
import chapterImg3 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.2.jpg';
import chapterImg4 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.3.jpg';
import chapterImg5 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.4.jpg';
import chapterImg6 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.5.jpg';
import chapterImg7 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.6.jpg';
import chapterImg8 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.7.jpg';
import chapterImg9 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.8.jpg';
import chapterImg10 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.9.jpg';
import chapterImg1 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.2.jpg';
import chapterImg11 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.3.1.jpg';
import chapterImg12 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.3.2.jpg';
import chapterImg13 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.3.3.jpg';
import chapterImg14 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.3.4.jpg';
import chapterImg15 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.3.5.jpg';
import chapterImg16 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.3.6.jpg';
import chapterImg17 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.3.7.jpg';
import chapterImg18 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.3.8.jpg';
import chapterImg19 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.3.9.jpg';
import chapterImg20 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.4.jpg';
import chapterImg21 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.5.jpg';
import chapterImg22 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.6.jpg';
import chapterImg23 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.7.jpg';
import chapterImg24 from '../../../../assets/images/courses/collaboration-fundamentals/chapter4.8.jpg';
import { CourseChapter } from '../../../../courses/courses.types';
import { CustomAccordion } from '../../../common/Accordion';
import { CarouselComponent } from '../../CarouselComponent';
import FlipCard from '../../FlipCard';
import { MediaBlock } from '../../MediaBlock';

interface CollaborationFundamentalsProps {
  chapter: CourseChapter;
  onNextChapter: (nextIndex: number) => void;
  totalPages: number;
  courseId?: string;
  onQuizResult?: (result: boolean | undefined) => void;
}

export const CollaborationFundamentalsChapter4: React.FC<CollaborationFundamentalsProps> = ({
  chapter,
  onNextChapter,
  totalPages,
  // courseId,
}) => {
  const handleNextChapterClick = () => {
    onNextChapter(chapter.index + 1);
  };

  const slidesData = [
    {
      heading: 'Accounting & Related Clerks',
      paragraph: `<p>... collaborate when assisting accountants and when working with partners to complete routine tasks. They may be members of administrative and office support teams, working together to ensure that services are provided efficiently. </p>`,
      list: [],
      image: chapterImg11,
    },
    {
      heading: 'Automotive Painters',
      paragraph: `<p> … may be required to coordinate activities with workers from body repair and vehicle preparation departments to ensure a smooth supply of vehicles to be painted. Automotive painters may also work directly with co-workers who assist them with vehicle preparation duties, such as sanding and masking.</p>`,
      list: [],
      image: chapterImg12,
    },
    {
      heading: 'Computer Network Technicians',
      paragraph: `<p>... coordinate and integrate job tasks with co-workers, such as programmers, technical support staff, system analysts, other network and web technicians and supervisors.</p>`,
      list: [],
      image: chapterImg13,
    },
    {
      heading: 'Construction Electricians',
      paragraph: `<p>.. work primarily with other construction electricians but may also interact with a wide variety of workers including apprentices, supervisors, owners' representatives, architects, engineers, inspectors, and suppliers.</p>`,
      list: [],
      image: chapterImg14,
    },
    {
      heading: 'Gas Fitters',
      paragraph: `<p>When completing larger jobs, gas fitters work with helpers or other crew members, and may coordinate the tasks of subcontractors. They work beside other subcontractors integrating activities and sharing space to avoid job site congestion. They work as first response team leaders when responding to an emergency gas leak.</p>`,
      list: [],
      image: chapterImg15,
    },
    {
      heading: 'Kitchen Helpers & Line Cooks',
      paragraph: `<p>... work both independently and as part of a team. They participate in formal discussions with co-workers and supervisors on methods for improving work processes or product quality, and on the allocation of responsibilities.</p>`,
      list: [],
      image: chapterImg16,
    },
    {
      heading: 'Machinists',
      paragraph: `<p>... work independently and with others. They work independently to interpret, plan and produce or repair parts. They work with other machinists to carry out new or complex tasks or to solve problems. For example, they may work with partners or maintenance staff to troubleshoot equipment failures.</p>`,
      list: [],
      image: chapterImg17,
    },
    {
      heading: 'Steam- & Pipefitters',
      paragraph: `<p>... work with others most of the time. They liaise with other steam- and pipefitters …. They work mainly with welders to assemble fittings prior to welding but may also work with pipe insulators and electricians. They coordinate the arrival times of crane operators when necessary. They work closely with apprentices to obtain assistance and to offer both technical training and safety information. Coordination of work with others is a key part of the occupation.</p>`,
      list: [],
      image: chapterImg18,
    },
    {
      heading: 'Welders',
      paragraph: `<p>Most welders' tasks are completed independently, but they must work with other team members, including fitters, other welders, and supervisors to plan work, confirm measurements and calculations, assist co-workers with tasks and schedule sharing of equipment. Journeypersons may coach and receive assistance from apprentices. They may also be partnered with workers from other trades, such as pipefitters, to co-ordinate their tasks on projects so that steps are completed in the right order.</p>`,
      list: [],
    },
    {
      heading: 'Web Designers & Developers',
      paragraph: `<p>... mainly work independently when designing and developing web sites. On larger projects, they coordinate tasks and exchange information with other team members …. They may work as team members or leaders … They may demonstrate, train and assign tasks to junior web designers.</p>`,
      list: [],
      image: chapterImg19,
    },
  ];
  const accordionData1 = [
    {
      id: 'panel1',
      title: 'Athletes',
      content:
        'Athletes like runners work independently when they train in the gym or run long distances alone. They work with a partner when they train with a running buddy or participate with the coach to review their performance on video. Many runners compete as part of a school or organizational team. They participate in leadership activities such as making suggestions on improving training schedules, leading race team warm-ups, and orienting new runners.',
      image: chapterImg22,
    },
    {
      id: 'panel2',
      title: 'Members of Environmental Groups',
      image: chapterImg23,
      content:
        'Members of environmental groups work independently when they conduct online research to follow current events and scientific developments related to their cause. They work with a partner when they canvass door to door or at shopping centers to raise funds for their group. They work as part of a team when they plan information fairs. They participate in leadership activities when they make presentations to larger regional or national groups on behalf of their own organization.',
    },
    {
      id: 'panel3',
      title: 'Student Filmmaker',
      image: chapterImg24,
      content:
        'Student filmmakers may first work independently to develop a script idea and later partner with another person to write the script. They may cast actors for the film alone or work with a partner who can provide a second opinion. They work as part of a team to ensure the film gets made. They participate in leadership activities when they act as the film’s director, ensuring everyone is following their instructions to achieve the vision they want to convey.',
    },
  ];

  return (
    <>
      <div className="content-wrap lg:border-l lg:pl-8 lg:pt-8 pt-4 pb-10">
        <p className="text-sm italic  mb-7">
          Part {chapter.index} of {totalPages}
        </p>
        <h2 className="font-semibold text-3xl">Collaboration in Action</h2>

        <MediaBlock mediaImage={introImg}>
          <p className="text-xl text-left font-light mt-5 mb-5">
            Every advance, every conceptual achievement of mankind has been connected with an
            advance in self awareness."
            <br />
            <br />– Dr. Carl Jung
          </p>
        </MediaBlock>
        <h3 className="text-2xl text-purple-600 font-bold mt-7 mb-1">
          Collaboration is Critical for Many Jobs
        </h3>

        <div className="md:flex items-center mb-7">
          <p className="flex-1">
            Some workers couldn’t safely do their job without the help of a partner. Crane operators
            work closely with a ground crew partner or ‘signaler’ to get the job done and keep the
            site safe.
            <br />
            <br />
            For example. They use hand signals to communicate with each other on where to move the
            crane boom, when to stop and when to raise and lower a load.
          </p>
          <br />
          <br />
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg1} alt="" />
          </div>
        </div>

        <h2 className="font-semibold text-2xl">Cool jobs that rely on collaboration! </h2>
        <p className="text-sm mt-7 mb-7">Click the images to learn more</p>

        <div className="my-10">
          <div className="flex justify-center gap-5 mb-7">
            <FlipCard>
              <div className="front-content text-center">
                <img className="w-full h-full object-contain" src={chapterImg2} alt="" />
              </div>
              <div className="back-content text-center  w-full h-full flex items-center justify-center">
                <div>
                  <p>Professional Chef</p>
                </div>
              </div>
            </FlipCard>
            <FlipCard>
              <div className="front-content w-full h-full">
                <img className="w-full h-full object-contain" src={chapterImg3} alt="" />
              </div>
              <div className="back-content text-center">
                <p>Crane Operator</p>
              </div>
            </FlipCard>
            <FlipCard>
              <div className="front-content w-full h-full">
                <img className="w-full h-full object-contain" src={chapterImg4} alt="" />
              </div>
              <div className="back-content text-center">
                <p>Game Designer</p>
              </div>
            </FlipCard>
          </div>
          <div className="flex justify-center gap-5 mb-7">
            <FlipCard>
              <div className="front-content text-center">
                <img className="w-full h-full object-contain" src={chapterImg5} alt="" />
              </div>
              <div className="back-content text-center  w-full h-full flex items-center justify-center">
                <div>
                  <p>Formula 1 Mechanic</p>
                </div>
              </div>
            </FlipCard>
            <FlipCard>
              <div className="front-content w-full h-full">
                <img className="w-full h-full object-contain" src={chapterImg6} alt="" />
              </div>
              <div className="back-content text-center">
                <p>Music Producer</p>
              </div>
            </FlipCard>
            <FlipCard>
              <div className="front-content w-full h-full">
                <img className="w-full h-full object-contain" src={chapterImg7} alt="" />
              </div>
              <div className="back-content text-center">
                <p>Aerospace Technician</p>
              </div>
            </FlipCard>
          </div>
          <div className="flex justify-center gap-5 mb-7">
            <FlipCard>
              <div className="front-content text-center">
                <img className="w-full h-full object-contain" src={chapterImg8} alt="" />
              </div>
              <div className="back-content text-center  w-full h-full flex items-center justify-center">
                <div>
                  <p>Architect</p>
                </div>
              </div>
            </FlipCard>
            <FlipCard>
              <div className="front-content w-full h-full">
                <img className="w-full h-full object-contain" src={chapterImg9} alt="" />
              </div>
              <div className="back-content text-center">
                <p>Marine Biologist</p>
              </div>
            </FlipCard>
            <FlipCard>
              <div className="front-content w-full h-full">
                <img className="w-full h-full object-contain" src={chapterImg10} alt="" />
              </div>
              <div className="back-content text-center">
                <p>Robotics Engineer</p>
              </div>
            </FlipCard>
          </div>
        </div>

        <h2 className="font-semibold text-2xl">Workplace Tasks that Depend on Collaboration </h2>
        <p className="text-xl text-left font-light mt-5 mb-5">
          Check out these 10 examples of real workplace tasks that depend on collaboration.
        </p>

        <div className="border rounded-3xl mr-8">
          <CarouselComponent data={slidesData} isRequired={false} />
        </div>
        <h3 className="text-2xl text-purple-600 font-bold mt-4 mb-1">
          Collaboration in the Real World
        </h3>
        <p className="text-xl text-left font-light mt-5 mb-5">
          As technology advances, more and more work is done using virtual teams. Check out this
          inventor who worked with a virtual team to build a wireless backup camera.
        </p>

        <h3 className="text-xl font-bold mt-4 mb-1">Backup Cameras – Renny Whipp</h3>
        <p className="text-xl text-left font-light mt-5 mb-5">
          People love backup cameras on vehicles. It’s safer and easier to reverse while watching a
          screen display of what’s behind your car or truck, but less than a quarter of all vehicles
          have backup cameras right now.
        </p>

        <div className="md:flex items-center mb-7">
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg20} alt="" />
          </div>
          <p className="flex-1">
            Making it easy to instantly add and remove a backup camera from any vehicle is what
            inventor Renny Whipp has done, and his story is interesting because he couldn’t have
            succeeded until now, when the internet made it possible to create a skilled team of
            experts able to collaborate while living in separate geographical locations.
          </p>
          <br />
          <br />
        </div>

        <div className="md:flex items-center mb-7">
          <p className="flex-1">
            The Hindsight camera delivers a wireless video signal to a smartphone or tablet on the
            dash of your vehicle. The quick-release base of the camera fastens to any car, truck, RV
            or transport truck, using controllable magnets and a no-mar adhesive. No bolt holes or
            wiring required.
          </p>
          <br />
          <br />
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg21} alt="" />
          </div>
        </div>

        <p className="text-xl text-center font-light flex-1 mt-5 mb-5">
          The system has a working range of more than 80 feet and a warning system in case you back
          up too close to vehicles, buildings, or people. Back up cameras make work life easier, and
          safer, for all workers who drive vehicles in their jobs.
        </p>

        <h3 className="text-xl font-bold mt-4 mb-1">
          What kinds of jobs do people have who work on cool projects like this one?
        </h3>
        <p className="text-xl text-center font-light flex-1 mt-5 mb-5">Here's a few:</p>
        <ul className="list-disc pl-5 mb-14 text-xl font-light">
          <li className="pl-9 mb-7">Electronic Products Designer</li>
          <li className="pl-9 mb-7">Industrial Designer </li>
          <li className="pl-9 mb-7">Computer Programmer</li>
          <li className="pl-9 mb-7">Robotics Technologist</li>
          <li className="pl-9 mb-7">Manufacturing Technician</li>
          <li className="pl-9 mb-7">Electrical Engineering Technologist</li>
        </ul>

        <h3 className="text-2xl text-purple-600 font-bold mt-4 mb-1">Ways We Collaborate</h3>
        <p className="text-xl font-light flex-1 mt-5 mb-5">
          There are lots of ways we collaborate with others, whether at a job or in our daily lives.
          Below are descriptions of ways in which individuals collaborate in three different
          activities. They are activities you might do at school, as a hobby, or as a volunteer
          commitment.
        </p>

        <p className="text-l  font-light mb-8">Click the '+' icons to learn more.</p>
        {accordionData1.map((data) => (
          <CustomAccordion
            key={data.title}
            title={data.title}
            content={data.content}
            id={data.id}
            image={data?.image}
          />
        ))}

        <h3 className="text-2xl mt-2  text-center font-light mb-5">
          Next we'll look at preferences through the application in of Social Perceptiveness &
          Insights Discovery.
        </h3>
        <button onClick={handleNextChapterClick} className="btn-internal w-full">
          Engagement Preferences
        </button>
      </div>
    </>
  );
};
